import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCircleHalfFill: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="circle-half-fill, contrast"><path fillRule="evenodd" clipRule="evenodd" d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5V20.5ZM22 12C22 17.5228 17.5228 22 12 22C11.7275 22 11.4573 21.9891 11.19 21.9676C6.04558 21.5549 2 17.2502 2 12C2 6.74975 6.04558 2.44515 11.19 2.03237C11.4573 2.01092 11.7275 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCircleHalfFill;
